import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const PlainText = ({ data }) => (
  <Flex w="100%" h="100%" alignItems="center">
    <TextBodyMedium>{data.name}</TextBodyMedium>
  </Flex>
);

export default PlainText;
